import { DateTime } from 'luxon'

import { EventResponseDTO } from '@/core/api/dtos/response/zone/event'
import { Event } from '@/core/api/entities/zone/event'

export class EventMapper {
	static toEntity(data: EventResponseDTO): Event {
		return Event.create({
			playerId: data.player_id,
			eventName: data.event_name,
			description: data.description,
			path: data.path,
			origin: {
				title: data.origin.title,
				advertName: data.origin.advert_name,
				announcementName: data.origin.announcement_name,
				radioId: data.origin.radio_id,
				segmentId: data.origin.segment_id,
				segmentName: data.origin.segment_name,
			},
			createdAt: DateTime.fromISO(data.created_at),
			isTimeAssumed: data.is_time_assumed,
		})
	}

	static toEntities(data: EventResponseDTO[]): Event[] {
		return data.map(this.toEntity)
	}
}
